import React from "react";
import {StaticQuery,graphql} from "gatsby";
import Profiles from '../components/body/profile'
import Hero from '../components/hero'
import {Section,Title} from 'bloomer';
import  {keys} from 'lodash';
import PropTypes from "prop-types";

const staffSections = {
  junior:'Junior School Teaching Staff',
  senior:'High School Teaching Staff',
  nonAcademic: 'Non-Teaching Staff'
}
const Component = ({onClick,defaultImage,heroClass}) => {
  return (
    <StaticQuery
      query={graphql `{
  markdownRemark(frontmatter:{templateKey:{eq:"staff-page"}}){
    frontmatter{
      junior{
        name
        jobTitle
        gender
        qualification
        description
        image{
          src
          alt
        }
      }
      senior{
       	name
        jobTitle
        gender
        qualification
        description
        image{
          src
          alt
        }
      }
      nonAcademic{
        name
        jobTitle
        gender
        qualification
        description
        image{
          src
          alt
        }
      }
    }
  }
}`}
      render={(data)=>{
        const staffProfiles=data.markdownRemark.frontmatter
        const sections = keys(staffProfiles);
        return(
          <div>
          <div id="carousel-wrap">
            <Hero
              className={heroClass}
              images={[]}
              getBody={()=><Title style={{marginTop:'1em'}} className='is-hidden-mobile'>
                Staff Roll-Call
              </Title>}
            />
          </div>
            {sections.map((section)=>(
            <Section className={'row'}>
              <Title>{staffSections[section]}</Title>
                  <Profiles
                    defaultImage={defaultImage}
                    key={section}
                    profiles={staffProfiles[section]}
                    onClick={onClick}
                  />
            </Section>
            ))}
          </div>)
      }}
    />
  );
};

Component.propTypes = {
  onClick:PropTypes.func,
  heroClass:PropTypes.string,
};

Component.defaultProps={
  defaultImage:{
    alt:'Executive team',
    src: '/img/avatar.png'
  }
}
export default Component;
